<template>
  <div class="preview">
    <el-button type="outline" size="small" @click="$emit('change')">
      Custom date
      <span class="text-black text-bold">
        : {{ mFormatShortDate(customDate.start_at, "d-m-y") }} -
        {{ mFormatShortDate(customDate.end_at, "d-m-y") }}
      </span>
    </el-button>
    <el-button type="primary" plain @click="$emit('clear')" size="small">
      Clear</el-button
    >
  </div>
</template>
<script>
export default {
  name: "RaCustomPeriodPreview",
  props: {
    customDate: {
      type: Object,
      default() {
        return {
          start_at: "",
          end_at: ""
        };
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.preview {
  display: flex;
  align-items: center;

  .date {
    height: 40px;
    background: transparent;
  }
}
</style>
